export default {
  defaultImg: {
    company: 'https://oss.1qizhuang.com/image/app/default-company.png',
    project: 'https://oss.1qizhuang.com/image/app/default-project.png',
    person: 'https://oss.1qizhuang.com/image/app/default-person.png',
    community: 'https://oss.1qizhuang.com/image/app/default-community.png',
    case: 'https://oss.1qizhuang.com/image/app/default-case.png',
    caseSquare: 'https://oss.1qizhuang.com/image/app/default-case-square.png',
    vrLoading: 'https://oss.1qizhuang.com/image/app/vr-loading.jpg'
  },
  icon: {
    upRedArrow: require('../assets/image/icon/red-up-arrow.png')
  }
}
